@let item = cartItem$();
<div class="button-group">
	@if (shouldShowRetry$()) {
		<button
			mat-button
			type="button"
			class="btn-retry-preflight"
			(click)="retryPreflight.emit($event)"
			(keyup.enter)="retryPreflight.emit($event)"
			i18n="@@RetryPreflightButton"
		>
			Retry
		</button>
	}
	<a
		type="button"
		mat-button
		[routerLink]="['/product', item.product.id, item.product.slug ?? '', 'edit', item.id]"
		tabindex="0"
		class="btn-change-printfile"
		i18n="@@PrintfileReportPrintfileChange"
		>Change</a
	>
</div>
